export default {
 footer: {
     ageRestriction: "Nossa plataforma é estritamente para maiores de 18 anos. Jogar pode ser viciante. Por favor, jogue com responsabilidade e apenas por entretenimento. Para mais informações, visite nossa página de Jogo Responsável.",
     followUs: "SIGA-NOS",
     company: "EMPRESA",
     legal: "JURÍDICO",
     support: "SUPORTE",
     gameProviders: "PROVEDORES DE JOGOS",
     copyright: "Copyright © 2019-2026 LOGO. Todos os direitos reservados.",
	 documents: "Documentos",
   }
}
